import { all } from "redux-saga/effects";
import { watchCitySaga } from "./city";
import { watchClientSaga } from "./client";
import { watchClientSpocSaga } from "./clientSpoc";
import { watchContactSaga } from "./contact";
import { watchCountrySaga } from "./country";
import { watchFloorSaga } from "./floor";
import { watchIndustrySaga } from "./industry";
import { watchLeadSaga } from "./leads";
import { watchLocationSaga } from "./location";
import { watchSuiteSaga } from "./suite";
import { watchSmartProposalSaga } from "./smart-proposal";
import { watchStateSaga } from "./state";
import { watchSideMenuSaga } from "./getSideMenu";
import { watchBrokerFirmSaga } from "./BrokerFirm";
import { watchBrokerOwnerSaga } from "./brokerOwner";
import { watchBrokerUserSaga } from "./brokerUser";
import { watchOwnerListSaga } from "./manage-property/property-owner/owner-data/ownerList";
import { watchLocations } from "../sagas/Locations/location-list";
import { watchBusinessUnit } from "../sagas/BusinessUnit/businessUnit-list";
import { watchLoiListSaga } from "./manage-property/property-loi/LOIDetails/loiDetails-list";
import { watchMainAgreementListSaga } from "./manage-property/property-agreement/mainAgreement-details";
import { watchSubAgreementListSaga } from "./manage-property/property-agreement/subAgreement-details";
import { watchPropertyOwnerSaga } from "./property-owner/propertyOwner-details";
import { watchbusinessCenterSaga } from "./businessCenter";
import { watchmanageUserSaga } from "./manageUser";
import { watchBusinessProposalSaga } from "./public-proposal";
import { watchmanageRoleSaga } from "./manageRoles";
import { watchFeatureSaga } from "./feature";
import { watchRegionSaga } from "./Region";
import { watchSalutationSaga } from "./salutation";
import { watchAgreementSaga } from "./smartSuiteAgreement";
import { watchAccountSaga } from "./account";
import { watchKpisSaga } from "./kpis";
import { watchWorkstation } from "./workstation";
import { watchClientExitChecklistSaga } from "./clientExitChecklist";
import { watchOccupancyTrackerSaga } from "./occupancyTracker";
import { watchDashboardSaga } from "./dashboard";
import { watchPermissionSaga } from "./permissions";
import rootSagaacclgl from "./acclgl";
import { watchMomSaga } from "./mom";
import { watchMarketingLeadSaga } from "./marketingLead";
export default function* rootSaga(getState) {
  yield all([
    watchBrokerFirmSaga(),
    watchBrokerUserSaga(),
    watchBrokerOwnerSaga(),
    watchOwnerListSaga(),
    watchLocations(),
    watchBusinessUnit(),
    watchLoiListSaga(),
    watchMainAgreementListSaga(),
    watchSubAgreementListSaga(),
    watchSmartProposalSaga(),
    watchLeadSaga(),
    watchLocationSaga(),
    watchSuiteSaga(),
    watchFloorSaga(),
    watchStateSaga(),
    watchCitySaga(),
    watchCountrySaga(),
    watchIndustrySaga(),
    watchClientSpocSaga(),
    watchContactSaga(),
    watchClientSaga(),
    watchPropertyOwnerSaga(),
    watchbusinessCenterSaga(),
    watchmanageUserSaga(),
    watchmanageRoleSaga(),
    watchFeatureSaga(),
    watchRegionSaga(),
    watchSalutationSaga(),
    watchBusinessProposalSaga(),
    watchAgreementSaga(),
    watchSideMenuSaga(),
    watchAccountSaga(),
    watchKpisSaga(),
    watchWorkstation(),
    watchClientExitChecklistSaga(),
    watchOccupancyTrackerSaga(),
    watchMomSaga(),
    watchMarketingLeadSaga(),
    watchDashboardSaga(),
    watchPermissionSaga(),
    ...rootSagaacclgl(),
  ]);
}
